import {
  useQuery,
} from '@tanstack/react-query'
import {
  organizationService,
} from '../services/api'
import {
  useAuth,
} from './useAuth'

export const ORGANIZATION_ACCESS_QUERY_KEY = ['organization-access']

/**
 * Whether the enterprise team board is available to the current user, and in
 * what capacity. Backend-authoritative (the `enterprise-organizations` flag is
 * evaluated server-side), so the nav entry and the page always agree.
 */
export function useOrganizationAccess(): {
  enabled: boolean
  hasOrganization: boolean
  isOrgAdmin: boolean
  domainRedactionEnabled: boolean
  hasWorkspaceTenant: boolean
  autoJoinDisabled: boolean
  isLoading: boolean
} {
  const { isAuthenticated } = useAuth()
  const query = useQuery({
    queryKey: ORGANIZATION_ACCESS_QUERY_KEY,
    queryFn: () => organizationService.getAccess(),
    enabled: isAuthenticated,
  })
  return {
    enabled: query.data?.enabled ?? false,
    hasOrganization: query.data?.has_organization ?? false,
    isOrgAdmin: query.data?.is_org_admin ?? false,
    // Server-side flag evaluation, like `enabled` — so the private-domains
    // card can never appear for someone the endpoints behind it would refuse.
    domainRedactionEnabled: query.data?.domain_redaction_enabled ?? false,
    // Whether this account's identity provider asserts a company directory, and
    // whether auto-join has already been switched off for it. Both drive the
    // "it's just me" control, which is meaningless for a personal account.
    hasWorkspaceTenant: query.data?.has_workspace_tenant ?? false,
    autoJoinDisabled: query.data?.auto_join_disabled ?? false,
    isLoading: query.isLoading,
  }
}
